<template>
  <div class="booking-form-frontpage">

      <div class="category-buttons" >
        <b-button
            v-for="button in groupedCategory"
            class="categoryButton buttontext"
            :class="{activeButton: selectedGroupedCategory.includes(button.id)}"
            @click="updateGroupedCategory(button.id)">{{button.description}}
        </b-button>
      </div>

      <div id="booking-form-bottom">

        <div class="inputrow">

          <!-- Pickup location data -->
          <div class='inputrowitemlocation' id='pickupLocation'>

              <location-control-version2
                  :bookViewFilter = true
                  v-bind:value="pickUpLocationId"
                  v-bind:locations="locations"
                  v-bind:active="selectPickUpLocation"
                  v-bind:label="pickUpLocationLabel"
                  @update-location="updatePickupLocation"
              ></location-control-version2>

          </div>

          <!-- PickUp Date and Time-->
          <div class="inputrowitemdatetime date">
              <date-time-input-separated
                  :datelabel="pickUpDateLabel"
                  :timelabel="pickUpTimeLabel"
                  :widgetType = '0'
                  :bookViewFilter = true
                  :minDate="minDate"
                  :location="pickupLocation"
                  id="pickUpDateTimeInput"
                  v-model="pickUpDateTime"
                  @update-date="updatePickupDateTime"
              ></date-time-input-separated>

          </div>

        </div>
        <div class="inputrow">

          <!-- Return location data -->
          <div class="inputrowitemlocation">
              <location-control-version2
                  :bookViewFilter = true
                  v-bind:value="returnLocationId"
                  v-bind:locations="locations"
                  v-bind:active="selectReturnLocation"
                  v-bind:label="returnLocationLabel"
                  @update-location="updateReturnLocation"
              ></location-control-version2>
          </div>

          <!-- Return Date and time -->
          <div class="inputrowitemdatetime time">

              <date-time-input-separated
                  :widgetType = '1'
                  :bookViewFilter = true
                  :datelabel="returnDateLabel"
                  :timelabel="returnTimeLabel"
                  :minDate="pickUpDateTime"
                  :location="returnLocation"
                  id="returnDateTimeInput"
                  v-model="returnDateTime"
                  v-on:click="beginSelectReturnDateTime()"
                  v-on:focus="beginSelectReturnDateTime()"
                  @update-date="updateReturnDateTime"
              ></date-time-input-separated>
            </div>
        </div>
        <div class="form-group">
          <button
              class="option-footer-button"
              v-on:click.prevent="fetchQuotes()"
              :disabled="!canFetchQuotes"
          >
          {{ $t('message.showCars') }}
          </button>
        </div>
      </div>

  </div>
</template>

<script>
import moment from "moment";
import "moment-timezone";
import LocationDetails from "../components/LocationDetails";
import LocationMap from "../components/LocationMap";
import DateTimeInput from "../components/DateTimeInputNative";
import { PickUpReturnStates } from "../services/pickupReturnStates";
import { mapActions, mapGetters } from "vuex";
import LocationList from '../components/LocationList.vue';
import LocationControl from '../components/LocationControl.vue';
import GroupedCategoryControl from '../components/GroupedCategoryControl.vue'
import VueI18n from 'vue-i18n';
import Axios from "axios";
import dayjs from 'dayjs/esm/index.js'

import DateTimeInputSeparated from "../components/DateTimeInputNativeSeparated.vue";

import LocationControlVersion2 from '../components/LocationControl2.vue';

export default {
  name: "BookFilterQuote",
  data() {
    return {
      // extern URL to be called, oif urlparameterData.sendMessage == false
      externUrl: process.env.VUE_APP_EXTERNAL_URL,

      // URL query parameter, deafult false to open new window
      urlparameterData: { sendMessage: false },

      minDate: "",
      min2Date: "",
      showMap:false,
      oneway: false,
      isHidden:true,
      locationSelected: 1,
      // Pick UP Location
      selectPickUpLocation: false,
      pickUpLocationId: 0,
      pickupLocation:{
        name: "My Location",
        address: "",
        zipAndCity: "",
        openingHours: "",
        latLion:{lat:0.0,lon:0.0},
        id: 0,
      },
      locationOpeningTimes: {},
      pickUpLocationLabel:this.$t('message.pickUpLocation'),//'Pick-Up Location',
      pickUpLocationText: "",
      // Pick UP Date
      selectPickUpDateTime: null,
      pickUpDateTime: "",
      pickUpTimeLabel:this.$t('message.pickUpTime'),//"Pick-Up time",
      pickUpDateLabel:this.$t('message.pickUpDate'),//"Pick-Up date",
      // Return Location
      selectReturnLocation: false,
      returnLocationId:0,
      returnLocation: {
        name: "My Location",
        address: "",
        zipAndCity: "",
        openingHours: "",
        latLion:{lat:0.0,lon:0.0},
        id: 0,
      },
      returnLocationLabel:this.$t('message.returnLocation'),//"Return location",
      returnLocationText: "",
      // Return Date
      pickUpReturnState: PickUpReturnStates.INITIAL,
      selectReturnDateTime: null,
      returnDateTime: "",
      returnDateLabel:this.$t('message.returnDate'),
      returnTimeLabel:this.$t('message.returnTime'),//"Return time",
      showFilter:false,
      filterPrice:0,
      quoteFetchErrorText: "",
      bgPath: process.env.VUE_APP_BG_PATH,

      // GroupedCategories
      groupedCategory: [],
      selectedGroupedCategoryID: null,
      selectedGroupedCategory: [],
    };
  },

  async created() {
    this.showLoader();

    // check if URL query parameter sendMessage was used
    const search = this.$route.query;
     if (Object.hasOwn(search, 'sendMessage')) {
        this.urlparameterData.sendMessage = search.sendMessage.toLowerCase() === "true" ? true : false;
     }

    try {
      await this.getLocations();
      this.groupedCategory = await this.getGroupedCategories()
      console.log("this.groupedCategory",this.groupedCategory)
      // preselect active groupedCategorys
      for(let item of this.groupedCategory){
        console.log("created - groupedCategory ", item.active);
        if(item.active === 1){
          this.updateGroupedCategory(item.id);
        }
      }

      this.hideLoader();

    } catch (error) {
      this.quoteFetchErrorText = error;
      this.hideLoader();
    }


  },
  async mounted() {
      const today = dayjs().set('hour', 12).set('minute', 0).set('second', 0);
      // tommorrow
      const date2 = today.add(24, 'hour');
      // day after tommorrow
      const date3 = date2.add(24, 'hour');

      var today2 = new Date();
      this.minDate=today2;
      this.pickUpDateTime=date2.toDate();
      this.returnDateTime=date3.toDate();

  },
  methods: {
    ...mapActions(["getLocations"]),
    showLoader() {
      this.$bus.$emit("showLoader");
    },
    hideLoader() {
      this.$bus.$emit("hideLoader");
    },


    /**
     * get the groupedCategories, which are used for a dropdown list for a category
     * preselection in the Quotes component
     */
    getGroupedCategories: async function() {
      try
      {
        const result = await Axios.get(`groupedcategory`);
        if (result.status != "200") throw new Error(result);
        return result.data;
      } catch (err) {
        console.error(err);
        return [];
      }
    },


    updatePickupLocation(location) {

      this.pickUpLocationId = location;
      this.selectPickUpLocation = true;
      this.isHidden=true;

      const loc = this.locations.filter((x) => x.id == location)[0];
      if (loc) {
        this.pickupLocation = loc;
      }
      else{
        this.pickupLocation={
          name: "My Location",
          address: "",
          zipAndCity: "",
          openingHours: "",
          latLion:{lat:0.0,lon:0.0},
          id: 0,
        };

      }

      this.updateReturnLocation(location);

    },
    updateReturnLocation(location) {
      this.returnLocationId = location;
      this.selectReturnLocation = true;
      this.isHidden=true;

      const loc = this.locations.filter((x) => x.id == location)[0];
      if (loc) {
        this.returnLocation = loc;
      }
      else{
        this.returnLocation={
          name: "My Location",
          address: "",
          zipAndCity: "",
          openingHours: "",
          latLion:{lat:0.0,lon:0.0},
          id: 0,
        };
      }

      //console.log("ReturnLocation updated! ", location);
    },
    updatePickupDateTime(newValue) {
      if(  (dayjs(newValue).format('YYYY-MM-DD')) === (dayjs(this.pickUpDateTime).format('YYYY-MM-DD'))  ){

        this.pickUpDateTime = newValue;

      } else{
        const today = dayjs(newValue);//new Date
        // tommorrow
        const date2 = today.add(24, 'hour');

        this.pickUpDateTime = newValue;

        this.updateReturnDateTime(date2.toDate());

      }


    },

    updateReturnDateTime(newValue) {

      this.returnDateTime = newValue;
      this.selectReturnDateTime=true;

    },

    updateGroupedCategory(newValue){

      if(this.selectedGroupedCategory.includes(newValue)){
        this.selectedGroupedCategory.splice(this.selectedGroupedCategory.indexOf(newValue),1);
      }else{
        this.selectedGroupedCategory.push(newValue);
      }

    },

    filterLocations: function(filter) {
      var picker = this.$refs.locationPicker;
      if (picker) {
        picker.filterLocations(filter);
      }
    },
    selectLocation: function(id) {
      var picker = this.$refs.locationPicker;
      if (picker) {
        picker.select(id);
      }
    },



    async fetchQuotes() {
      this.quote.data.items=[];
      this.selectedItem = null;
      let params = {};
      params.pickUpLocation = this.pickUpLocationId;
      if (this.oneway) params.returnLocation = this.returnLocation;
      else params.returnLocation = this.returnLocationId;
      params.pickUpDateTime = this.pickUpDateTime;
      params.returnDateTime = this.returnDateTime;
      params.driverAge = 30;

      let tmpSelctedCategories = [];
      for(let groupedCategoryId of this.selectedGroupedCategory){
        tmpSelctedCategories = tmpSelctedCategories.concat(this.groupedCategory.find((item)=> item.id===groupedCategoryId).categories);
      }
      params.selectedCategories = tmpSelctedCategories;

      sessionStorage.setItem('Book_page_state', JSON.stringify(params));

     

      const url2 = `${this.externUrl}?params=${encodeURIComponent(JSON.stringify(params))}`;

      this.quoteSearchInProgress = true;
      

      if (this.urlparameterData.sendMessage) {
        // parent component need to listen to message to recieve it!
        window.parent.postMessage(url2, '*');
      }else{
        var w = window.open(url2,"_parent");
      }
    },
    showModalError(msg) {
      //console.log(msg);
      return this.$bvModal
          .msgBoxOk(msg, {
            title: this.$t('message.error'),
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            headerClass: "p-2 rounded-0",
            footerClass: "p-2 rounded-0",
            centered: true,
            contentClass: 'rounded-0',
            headerClass: 'modal-header-black rounded-0',
          })
          .catch((err) => {
            console.error(err);
          });
    },

    help(){
      var ok=false;
      console.log("pickUpLocation: %d, returnLocation: %d, oneway: %d", this.pickUpLocationId, this.returnLocation, this.oneway);
      if (this.pickUpLocationId>0)
        if(this.returnLocationId>0)
          if(this.returnDateTime > this.pickUpDateTime)
            ok=true;
          else
            this.showModalError(this.$t('message.pickUpDateLaterThanReturnDate'));
        else
          this.showModalError(this.$t('message.noSelectedReturnLocation'));
      else
        this.showModalError(this.$t('message.noSelectedPickupLocation'));
    }

  },
  computed: {
    ...mapGetters(["locations", "insurances", "quote", "postBookingResult"]),

    showQuotes: {
      get() {
        return this.quote.data.items.length > 0 && this.selectedItem == null && this.showCarsDialog;
      },
      set() {
        this.selectedItem = null;
        this.showCarsDialog = false;
      },
    },
    showSelectedItem: {
      get() {
        return this.quote.data.items.length > 0 && this.selectedItem != null;
      },
      set() {
        this.unselectItem();
        this.showCarsDialog = true;
      },
    },
    canFetchQuotes() {
      //console.log("pickUpLocation: %d, returnLocation: %d, oneway: %d", this.pickUpLocationId, this.returnLocation, this.oneway);
      var ok = this.pickUpLocationId > 0 && (!this.oneway || this.returnLocation > 0);
      ok = ok && this.returnDateTime > this.pickUpDateTime;
      //console.log("canFetchQuotes: ", ok);
      return ok;
    },

  },
  components: {
    DateTimeInput,
    LocationControl,
    LocationDetails,
    LocationMap,
    LocationList,
    LocationControl,
    GroupedCategoryControl,
    DateTimeInputSeparated,
    LocationControlVersion2,
  },
};
</script>

<style lang="scss" scoped>
@media (max-width:471px ){
  .inputrowitemlocation{
    width: 40% !important;

  }
  .inputrowitemdatetime{
    width: 60% !important;
  }
}
@media (max-width:378px ){
  .inputrowitemlocation{
    width: 50% !important;

  }
  .inputrowitemdatetime{
    width: 50% !important;
  }
}
@media (max-width:323px ){
  .inputrowitemlocation{
    width: 60% !important;

  }
  .inputrowitemdatetime{
    width: 40% !important;
  }
}
.categoryButton {
  align-self: center;
  min-width: 160px;
  padding: 1.25rem 1.25rem;
  color: #00168d;
  background-color: #f2f2f2;
  border: none;
  border-radius: 0.6rem;
}
.buttontext{

  text-align: center;
  /* Text/Text 16 */
  font-family: Neue Helvetica,sans-serif;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1em;
}
.category-buttons{
  display: flex;
  flex-wrap: wrap;
  border-radius: .6rem;
  padding: 0.5rem;
  width: fit-content;
  margin: auto;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2.5rem;
  background-color: white;

  box-shadow: 0 4px 40px rgba(0,0,0,.1);

  .activeButton{
    background-color: #0064D7 !important;
    color: white !important;
  }

}
.category-buttons ::v-deep{
  .btn-secondary{
    margin-top:0;
  }


}

.option-footer-button{
  width: 100%;
  height: 58px;
  background-color: #f5501e;
  color: white;
  border-radius: 0.6rem;
  border: none;

  text-align: center;
  /* Text/Text 16 */
  font-family: Helvetica Neue;
  font-family: Neue Helvetica,sans-serif;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1em;
}
.option-footer-button:disabled{
  color: #00168d;
  background-color: #f2f2f2
}

.booking-form-frontpage{
  height: 672px;
  background-color: #0064D7;
  gap:35px;

}

#booking-form-bottom {
  display: flex;
  flex-direction: column;
  padding: 40px 40px 40px 40px;
  /*margin: auto;*/
  /*width: 50%;*/
  gap: 20px;
  background-color: #CEE4FE;
  border-radius: 0.6rem;
}

.inputrow {
  display: flex;
  gap: 20px;
}



.inputrowitemlocation{
  width: 30%;

}
.inputrowitemdatetime{
  width: 70%;
}

.input-group .form-control, .input-group .form-control:first-child, .input-group .form-control:last-child {
  border-radius: 0.6rem;
}

</style>